<template>
  <b-dropdown
    :id="id"
    :text="displayText"
    variant="dropdown"
    :class="
      `dropdown-icon-wrapper ${sizeClass} ${wrapperClass} ${stateClass}`
    "
    :menu-class="`shadow-sm mt-0 ${sizeClass}`"
    :toggle-class="`w-100 ${toggleClass}`"
    offset="0"
    :disabled="disabled"
  >
    <template #button-content>
      <b-spinner
        v-if="loading"
        variant="primary"
        small
        label="Text Centered"
      />
      <div
        v-else
        class="d-flex justify-content-between align-items-center w-100"
      >
        <div class="d-flex flex-column w-100 align-items-start">
          <span
            :class="`text-md mw-100 text-truncate lh-normal ${textColorClass}`"
          >
            {{ displayText }}
          </span>
          <span
            v-if="selectedItemDescription"
            class="text-xsm text-secondary mw-100 text-truncate lh-normal"
          >
            {{ selectedItemDescription }}
          </span>
        </div>
        <GjIcon
          class="icon-right"
          name="ArrowDown"
          size="18"
        />
      </div>
    </template>
    <b-dropdown-item
      v-for="option in options"
      :key="getKey(option.value)"
      :disabled="selectable ? !selectable(option) : false"
      :class="{active: value === option.value }"
      @click="onSelect(option.value)"
    >
      <div class="d-flex flex-column w-100">
        <div
          class="w-100"
          style="white-space:normal"
        >
          {{ option.text }}
        </div>
        <div
          v-if="option.description"
          class="w-100 text-xsm text-secondary"
          style="white-space:normal"
        >
          {{ option.description }}
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: 'CustomSelect',
  props: {
    state: {
      default: true,
      type: Boolean,
    },
    size: {
      default: null,
      type: String,
    },
    selectable: {
      default: null,
      type: Function,
    },
    id: {
      default: null,
      type: [String, Number],
    },
    wrapperClass: {
      default: null,
      type: String,
    },
    toggleClass: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      default: null,
      type: String,
    },
    options: {
      default: () => [],
      required: true,
      type: Array,
    },
    nestedValue: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // eslint-disable-next-line vue/require-default-prop
    value: null,
  },
  computed: {
    selectedItem() {
      const temp = this.nestedValue
        ? this.options.find(option => option.value?.text === this.value?.text)
        : this.options.find(option => option.value === this.value)
      return temp
    },
    displayText() {
      return this.selectedItem ? this.selectedItem.text : this.placeholder
    },
    selectedItemDescription() {
      return this.selectedItem?.description || null
    },
    stateClass() {
      if (this.size == null) return ''
      return this.state ? '' : 'border-danger'
    },
    textColorClass() {
      return this.selectedItem ? '' : 'text-secondary'
    },
    sizeClass() {
      return this.size === 'auto' ? '' : 'w-100'
    },
  },
  watch: {
    value(value) {
      this.$emit('change', value)
    },
  },
  methods: {
    getKey(value) {
      if (typeof value === 'object') {
        return JSON.stringify(value)
      }
      return value
    },
    onSelect(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.lh-normal {
  line-height: normal;
}
.active::v-deep {
  .dropdown-item {
    background-color: var(--primary) !important;
    color: var(--white) !important;
  }
}
</style>
